import LocationsListItem from "./LocationsListItem";

export default LocationsListItem;
